import React from 'react';
import { IonContent, IonGrid, IonRow, IonCol, IonCard, IonCardContent, IonButton } from '@ionic/react';
import { useHistory } from 'react-router';

// Components
import { MessageComponent, HeaderComponent } from '..';

// Constants
import { APP_CONFIG } from '../../constants';

// Helpers
import { isNative, isMobileWeb, sendEventMenu } from '../../helpers';


export const PermissionMessageComponent = ({
    message,
    title
}) => {

    const history = useHistory();
    const isMobile = isNative() || isMobileWeb();

    const handleRedirect = () => {

        // Analytics
        sendEventMenu('CONTACT');
        history.replace(APP_CONFIG.PAGES.CONTACT.path);
    };

    return (
        <>
            {
                isMobile &&
                <>
                    <HeaderComponent title={title} />
                    <IonContent className="ion-padding">
                        <MessageComponent
                            message={message}
                            urlImage="assets/images/error.png"
                        >
                            <IonButton
                                type="button"
                                shape="round"
                                size="undefined"
                                onClick={handleRedirect}>
                                CONTACTAR A CLN
                            </IonButton>
                        </MessageComponent>

                    </IonContent>
                </>
            }
            {
                !isMobile &&
                <IonContent className="ion-padding ion-text-center">

                    <IonGrid>
                        <IonRow className='ion-text-left'>
                            <IonCol>
                                <h1>{title}</h1>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonCard>
                                    <IonCardContent className="ion-text-center">
                                        <MessageComponent
                                            message={message}
                                            urlImage="assets/images/error.png"
                                        >
                                            <IonButton
                                                type="button"
                                                shape="round"
                                                size="undefined"
                                                onClick={handleRedirect}>
                                                SOLICITAR PERMISOS
                                            </IonButton>
                                        </MessageComponent>
                                    </IonCardContent>
                                </IonCard>
                            </IonCol>
                        </IonRow>
                    </IonGrid>

                </IonContent>
            }

        </>
    )
}
